<template>
  <div class="split-detail-manage">
    <!-- 面包屑导航 -->
    <!-- 卡片容器 -->
    <el-card>
      <!-- 搜索表单 -->
      <div class="filter-container">
        <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="85px">
          <el-form-item label="分账记录ID" prop="splitRecordId">
            <el-input
              v-model="queryParams.splitRecordId"
              placeholder="请输入分账记录ID"
              clearable
              style="width: 200px;"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="订单号" prop="orderNo">
            <el-input
              v-model="queryParams.orderNo"
              placeholder="请输入订单号"
              clearable
              style="width: 200px;"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="分账类型" prop="splitType">
            <el-select v-model="queryParams.splitType" placeholder="请选择分账类型" clearable style="width: 200px;">
              <el-option
                v-for="dict in splitTypeDict"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="目标ID" prop="targetId">
            <el-input
              v-model="queryParams.targetId"
              placeholder="请输入目标ID"
              clearable
              style="width: 200px;"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="分账状态" prop="splitStatus">
            <el-select v-model="queryParams.splitStatus" placeholder="请选择分账状态" clearable style="width: 200px;">
              <el-option
                v-for="dict in splitStatusDict"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="dateRange"
              style="width: 240px"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery" style="background-color: #3CA757; border-color: #3CA757;">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
            <el-button type="warning" icon="el-icon-download" @click="handleExport">导出</el-button>
          </el-form-item>
        </el-form>
      </div>

    <!-- 表格 -->
	  <el-table v-loading="loading" :data="splitDetailList" @selection-change="handleSelectionChange" border stripe>
		<el-table-column type="selection" width="55" align="center" />
		<el-table-column type="index" width="60" align="center" />
		<el-table-column label="分账记录ID" align="center" prop="splitRecordId"/>
		<el-table-column label="订单号" align="center" prop="orderNo"/>
		<el-table-column label="分账类型" align="center" prop="splitType">
			<template slot-scope="scope">
				<span :style="{ color: scope.row.splitType === '1' ? '#67C23A' : scope.row.splitType === '2' ? '#E6A23C' : '#409EFF' }">{{ getDictLabel(splitTypeDict, scope.row.splitType) }}</span>
			</template>
		</el-table-column>
		<el-table-column label="目标ID" align="center" prop="splitTargetId"/>
		<el-table-column label="目标名称" align="center" prop="splitTargetName"/>
		<el-table-column label="分账金额" align="center" prop="splitAmount">
			<template slot-scope="scope">
				{{ scope.row.splitAmount ? '¥' + scope.row.splitAmount : '-' }}
			</template>
		</el-table-column>
		<el-table-column label="分账比例" align="center" prop="splitRatio">
			<template slot-scope="scope">
				{{ scope.row.splitRatio ? (scope.row.splitRatio * 100).toFixed(2) + '%' : '-' }}
			</template>
		</el-table-column>
		<el-table-column label="分账状态" align="center" prop="splitStatus">
			<template slot-scope="scope">
				<span :style="{ color: scope.row.splitStatus === '1' ? '#67C23A' : scope.row.splitStatus === '2' ? '#F56C6C' : '#909399' }">{{ getDictLabel(splitStatusDict, scope.row.splitStatus) }}</span>
			</template>
		</el-table-column>
		<el-table-column label="创建时间" align="center" prop="createTime" width="180">
			<template slot-scope="scope">
				<span>{{ formatTime(scope.row.createTime) }}</span>
			</template>
		</el-table-column>
		<el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-view"
              @click="handleDetail(scope.row)"
            >详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryParams.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 分账明细详情对话框 -->
    <el-dialog title="分账明细详情" :visible.sync="detailOpen" width="800px" append-to-body>
      <el-descriptions :column="2" border class="detail-descriptions">
        <el-descriptions-item label="明细ID" label-class-name="detail-label">{{ detailForm.id }}</el-descriptions-item>
        <el-descriptions-item label="分账记录ID" label-class-name="detail-label">{{ detailForm.splitRecordId }}</el-descriptions-item>
        <el-descriptions-item label="订单号" label-class-name="detail-label">{{ detailForm.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="分账类型" label-class-name="detail-label">
          <el-tag :type="detailForm.splitType === '1' ? 'success' : detailForm.splitType === '2' ? 'warning' : 'info'" size="small">
            {{ getDictLabel(splitTypeDict, detailForm.splitType) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="目标ID" label-class-name="detail-label">{{ detailForm.splitTargetId }}</el-descriptions-item>
        <el-descriptions-item label="目标名称" label-class-name="detail-label">{{ detailForm.splitTargetName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="分账金额" label-class-name="detail-label">
          <span class="amount-text">{{ detailForm.splitAmount ? '¥' + detailForm.splitAmount.toFixed(2) : '-' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="分账比例" label-class-name="detail-label">
          <span class="ratio-text">{{ detailForm.splitRatio ? (detailForm.splitRatio * 100).toFixed(2) + '%' : '-' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="分账状态" label-class-name="detail-label">
          <el-tag :type="detailForm.splitStatus === '1' ? 'success' : detailForm.splitStatus === '2' ? 'danger' : 'info'" size="small">
            {{ getDictLabel(splitStatusDict, detailForm.splitStatus) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间" label-class-name="detail-label">{{ formatTime(detailForm.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间" label-class-name="detail-label">{{ formatTime(detailForm.updateTime) }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2" label-class-name="detail-label">{{ detailForm.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailOpen = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.filter-container {
  padding-bottom: 10px;
}
.filter-container .filter-item {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 10px;
  margin-right: 10px;
}

/* 表格样式增强 */
.el-table {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

/* 详情对话框样式增强 */
.detail-descriptions {
  margin-bottom: 20px;
}

.detail-label {
  font-weight: 600;
  color: #606266;
  background-color: #f5f7fa !important;
}

.amount-text {
  color: #E6A23C;
  font-weight: 600;
}

.ratio-text {
  color: #409EFF;
  font-weight: 600;
}
</style>

<script>

export default {
  name: "SplitDetailManage",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 分账明细表格数据
      splitDetailList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否显示详情弹出层
      detailOpen: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        page: 1,
        limit: 10,
        splitRecordId: null,
        orderNo: null,
        splitType: null,
        targetId: null,
        splitStatus: null,
      },
      // 表单参数
      form: {},
      // 详情表单参数
      detailForm: {},
      // 表单校验
      rules: {
        splitRecordId: [
          { required: true, message: "分账记录ID不能为空", trigger: "blur" }
        ],
        orderNo: [
          { required: true, message: "订单号不能为空", trigger: "blur" }
        ],
        splitType: [
          { required: true, message: "分账类型不能为空", trigger: "change" }
        ],
        targetId: [
          { required: true, message: "目标ID不能为空", trigger: "blur" }
        ],
        splitStatus: [
          { required: true, message: "分账状态不能为空", trigger: "change" }
        ]
      },
      // 静态字典数据
      splitTypeDict: [
        { label: '平台方', value: 1 },
        { label: '商户方', value: 2 },
        { label: '微信', value: 3 }
      ],
      splitStatusDict: [
        { label: '待分账', value: 0 },
        { label: '分账成功', value: 1 },
        { label: '分账失败', value: 2 }
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询分账明细列表 */
    getList() {
      this.loading = true;
      const requestData = this.addDateRange(this.queryParams, this.dateRange);
      this.$http.post('/split/detail/page', requestData).then(response => {
        console.log('response:', response);
        if (response.data.code === 200) {
          this.splitDetailList = response.data.data.list;
          this.total = response.data.data.total;
        } else {
          this.$message.error(response.data.msg);
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        splitRecordId: null,
        orderNo: null,
        splitType: null,
        targetId: null,
        targetName: null,
        splitAmount: null,
        splitRatio: null,
        splitStatus: "0",
        remark: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 详情按钮操作 */
    handleDetail(row) {
      this.detailForm = row;
      this.detailOpen = true;
    },
    /** 根据字典值获取标签 */
    getDictLabel(dictList, value) {
      const dict = dictList.find(item => item.value === value);
      return dict ? dict.label : value;
    },
    /** 格式化时间 */
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    /** 添加日期范围参数 */
    addDateRange(params, dateRange) {
      const search = params;
      search.beginTime = "";
      search.endTime = "";
      if (dateRange != null && dateRange.length === 2) {
        search.beginTime = this.formatTime(dateRange[0]);
        search.endTime = this.formatTime(dateRange[1]);
      }
      return search;
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('/split/detail/export', {
        ...this.queryParams
      }, `splitDetail_${new Date().getTime()}.xlsx`)
    },
    // 分页事件处理
    handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    // 对话框关闭事件处理
    handleDialogClose() {
      this.reset();
    }
  }
};
</script>